var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAddDoor = function SvgIconAddDoor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 27C25.5523 27 26 27.4477 26 28V30H28C28.5523 30 29 30.4477 29 31C29 31.5523 28.5523 32 28 32H26V34C26 34.5523 25.5523 35 25 35C24.4477 35 24 34.5523 24 34V32H22C21.4477 32 21 31.5523 21 31C21 30.4477 21.4477 30 22 30H24V28C24 27.4477 24.4477 27 25 27Z",
    fill: "#7CBA55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 9C25.5523 9 26 9.44771 26 10V24C26 24.5 25.5523 25 25 25C24.4477 25 24 24.5 24 24V21H22C21.4477 21 21 20.5523 21 20C21 19.4477 21.4477 19 22 19H24V11H16V30H18C18.5 30 19 30.4477 19 31C19 31.5523 18.5 32 18 32H15C14.4477 32 14 31.5523 14 31V10C14 9.44771 14.4477 9 15 9H25Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAddDoor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-add-door.87c405a0.svg";
export { ForwardRef as ReactComponent };